import React from "react";
import { useUser } from "../contexts/UserContext";
import { getAuthToken, getUserId } from "../services/authService";
import { registerBackofficeWebPush } from "../services/backofficeWebPush";

const BackofficeWebPushRegistration: React.FC = () => {
  const { user } = useUser();
  const attemptedRegistrationKeyRef = React.useRef<string>("");

  React.useEffect(() => {
    const token = getAuthToken();
    const userId = getUserId() || "";
    const registrationKey = token && userId ? `${userId}:${token}` : "";

    if (!registrationKey) {
      attemptedRegistrationKeyRef.current = "";
      return;
    }

    if (attemptedRegistrationKeyRef.current === registrationKey) {
      return;
    }

    attemptedRegistrationKeyRef.current = registrationKey;

    registerBackofficeWebPush().catch((error) => {
      attemptedRegistrationKeyRef.current = "";
      console.warn("Backoffice web push registration failed", error);
    });
  }, [
    user?.id,
    user?.email,
    user?.organizationId,
    user?.organization_id,
    user?.orgId,
  ]);

  return null;
};

export default BackofficeWebPushRegistration;
